<template>
    <img class="topImgSty" :src="pictureLang[$i18n.locale]">
</template>
<script>
export default {
    data() {
        return {
            pictureLang: {
                en: "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/16920997735118673938701506836.png",
                ja: "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/1692099980679902104842440355.jpg",
                "zh-cn": "https://bosum-erp-private-write.oss-cn-shenzhen.aliyuncs.com/1691425508583544523668541899.png",
            }
        }
    },
}
</script>
<style></style>
 


// WEBPACK FOOTER //
// src/components/topPicStudent.vue